/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Rocket.net API
 * Rocket.net - All APIs
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import { customFetch } from '../../custom-fetch';
import { addMetaToQuery } from '../../mutators/add-meta';
import { addMetaToMutation } from '../../mutators/add-meta';
import type {
  ActivateThemeRequest,
  ActivateThemeResponse,
  DeleteThemeRequest,
  DeleteThemeResponse,
  Error,
  InstallThemesRequest,
  InstallThemesResponse,
  ListSiteThemesParams,
  ListThemesResponse,
  SearchSiteThemesParams,
  SearchThemesResponse,
  SiteID,
  UpdateThemeRequest,
  UpdateThemeResponse,
} from '../rocketNetAPI.schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * Returns themes installed on this site, with status, version, and available updates. Supports search, pagination, and sorting. WordPress sites only.
 * @summary List installed WordPress themes
 */
export const listSiteThemes = (id: SiteID, params?: ListSiteThemesParams, signal?: AbortSignal) => {
  return customFetch<ListThemesResponse>({
    url: `/v1/sites/${id}/themes`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListSiteThemesQueryKey = (id?: SiteID, params?: ListSiteThemesParams) => {
  return [`/v1/sites/${id}/themes`, ...(params ? [params] : [])] as const;
};

export const getListSiteThemesQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteThemesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteThemes>>> = ({ signal }) =>
    listSiteThemes(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/themes`,
      operationId: 'app.controllers.themes_controller.list_site_themes',
      operationName: 'listSiteThemes',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof listSiteThemes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteThemesQueryResult = NonNullable<Awaited<ReturnType<typeof listSiteThemes>>>;
export type ListSiteThemesQueryError = Error;

export function useListSiteThemes<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteThemesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteThemes>>,
          TError,
          Awaited<ReturnType<typeof listSiteThemes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteThemes<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSiteThemes>>,
          TError,
          Awaited<ReturnType<typeof listSiteThemes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteThemes<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List installed WordPress themes
 */

export function useListSiteThemes<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteThemesQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getListSiteThemesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListSiteThemesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listSiteThemes>>> = ({ signal }) =>
    listSiteThemes(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/themes`,
      operationId: 'app.controllers.themes_controller.list_site_themes',
      operationName: 'listSiteThemes',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listSiteThemes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSiteThemesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSiteThemes>>
>;
export type ListSiteThemesSuspenseQueryError = Error;

export function useListSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | ListSiteThemesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List installed WordPress themes
 */

export function useListSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof listSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: ListSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof listSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListSiteThemesSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Installs one or more themes from the WordPress theme directory or from a custom download URL. Optionally sets a theme as active after install. WordPress sites only.
 * @summary Install WordPress themes
 */
export const installSiteTheme = (
  id: SiteID,
  installThemesRequest: InstallThemesRequest,
  signal?: AbortSignal
) => {
  return customFetch<InstallThemesResponse>({
    url: `/v1/sites/${id}/themes`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: installThemesRequest,
    signal,
  });
};

export const getInstallSiteThemeMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof installSiteTheme>>,
    TError,
    { id: SiteID; data: InstallThemesRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof installSiteTheme>>,
  TError,
  { id: SiteID; data: InstallThemesRequest },
  TContext
> => {
  const mutationKey = ['installSiteTheme'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof installSiteTheme>>,
    { id: SiteID; data: InstallThemesRequest }
  > = props => {
    const { id, data } = props ?? {};

    return installSiteTheme(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/themes` },
    {
      operationId: 'app.controllers.themes_controller.install_site_theme',
      operationName: 'installSiteTheme',
    }
  );

  return customOptions;
};

export type InstallSiteThemeMutationResult = NonNullable<
  Awaited<ReturnType<typeof installSiteTheme>>
>;
export type InstallSiteThemeMutationBody = InstallThemesRequest;
export type InstallSiteThemeMutationError = Error;

/**
 * @summary Install WordPress themes
 */
export const useInstallSiteTheme = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof installSiteTheme>>,
      TError,
      { id: SiteID; data: InstallThemesRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof installSiteTheme>>,
  TError,
  { id: SiteID; data: InstallThemesRequest },
  TContext
> => {
  const mutationOptions = getInstallSiteThemeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Activates or deactivates an installed theme by slug. WordPress sites only.
 * @summary Activate or deactivate a WordPress theme
 */
export const toggleSiteTheme = (id: SiteID, activateThemeRequest: ActivateThemeRequest) => {
  return customFetch<ActivateThemeResponse>({
    url: `/v1/sites/${id}/themes`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: activateThemeRequest,
  });
};

export const getToggleSiteThemeMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof toggleSiteTheme>>,
    TError,
    { id: SiteID; data: ActivateThemeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof toggleSiteTheme>>,
  TError,
  { id: SiteID; data: ActivateThemeRequest },
  TContext
> => {
  const mutationKey = ['toggleSiteTheme'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof toggleSiteTheme>>,
    { id: SiteID; data: ActivateThemeRequest }
  > = props => {
    const { id, data } = props ?? {};

    return toggleSiteTheme(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/themes` },
    {
      operationId: 'app.controllers.themes_controller.toggle_site_theme',
      operationName: 'toggleSiteTheme',
    }
  );

  return customOptions;
};

export type ToggleSiteThemeMutationResult = NonNullable<
  Awaited<ReturnType<typeof toggleSiteTheme>>
>;
export type ToggleSiteThemeMutationBody = ActivateThemeRequest;
export type ToggleSiteThemeMutationError = Error;

/**
 * @summary Activate or deactivate a WordPress theme
 */
export const useToggleSiteTheme = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof toggleSiteTheme>>,
      TError,
      { id: SiteID; data: ActivateThemeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof toggleSiteTheme>>,
  TError,
  { id: SiteID; data: ActivateThemeRequest },
  TContext
> => {
  const mutationOptions = getToggleSiteThemeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Updates an installed theme to its latest available version. WordPress sites only.
 * @summary Update a WordPress theme
 */
export const updateSiteTheme = (id: SiteID, updateThemeRequest: UpdateThemeRequest) => {
  return customFetch<UpdateThemeResponse>({
    url: `/v1/sites/${id}/themes`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateThemeRequest,
  });
};

export const getUpdateSiteThemeMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateSiteTheme>>,
    TError,
    { id: SiteID; data: UpdateThemeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateSiteTheme>>,
  TError,
  { id: SiteID; data: UpdateThemeRequest },
  TContext
> => {
  const mutationKey = ['updateSiteTheme'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateSiteTheme>>,
    { id: SiteID; data: UpdateThemeRequest }
  > = props => {
    const { id, data } = props ?? {};

    return updateSiteTheme(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/themes` },
    {
      operationId: 'app.controllers.themes_controller.update_site_theme',
      operationName: 'updateSiteTheme',
    }
  );

  return customOptions;
};

export type UpdateSiteThemeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateSiteTheme>>
>;
export type UpdateSiteThemeMutationBody = UpdateThemeRequest;
export type UpdateSiteThemeMutationError = Error;

/**
 * @summary Update a WordPress theme
 */
export const useUpdateSiteTheme = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateSiteTheme>>,
      TError,
      { id: SiteID; data: UpdateThemeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateSiteTheme>>,
  TError,
  { id: SiteID; data: UpdateThemeRequest },
  TContext
> => {
  const mutationOptions = getUpdateSiteThemeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Removes one or more installed themes. The active theme cannot be deleted. WordPress sites only.
 * @summary Uninstall a WordPress theme
 */
export const deleteSiteTheme = (id: SiteID, deleteThemeRequest: DeleteThemeRequest) => {
  return customFetch<DeleteThemeResponse>({
    url: `/v1/sites/${id}/themes`,
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    data: deleteThemeRequest,
  });
};

export const getDeleteSiteThemeMutationOptions = <TError = Error, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteSiteTheme>>,
    TError,
    { id: SiteID; data: DeleteThemeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteSiteTheme>>,
  TError,
  { id: SiteID; data: DeleteThemeRequest },
  TContext
> => {
  const mutationKey = ['deleteSiteTheme'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteSiteTheme>>,
    { id: SiteID; data: DeleteThemeRequest }
  > = props => {
    const { id, data } = props ?? {};

    return deleteSiteTheme(id, data);
  };

  const customOptions = addMetaToMutation(
    { ...mutationOptions, mutationFn },
    { url: `/v1/sites/{id}/themes` },
    {
      operationId: 'app.controllers.themes_controller.delete_site_theme',
      operationName: 'deleteSiteTheme',
    }
  );

  return customOptions;
};

export type DeleteSiteThemeMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteSiteTheme>>
>;
export type DeleteSiteThemeMutationBody = DeleteThemeRequest;
export type DeleteSiteThemeMutationError = Error;

/**
 * @summary Uninstall a WordPress theme
 */
export const useDeleteSiteTheme = <TError = Error, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteSiteTheme>>,
      TError,
      { id: SiteID; data: DeleteThemeRequest },
      TContext
    >;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteSiteTheme>>,
  TError,
  { id: SiteID; data: DeleteThemeRequest },
  TContext
> => {
  const mutationOptions = getDeleteSiteThemeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Searches themes available from the WordPress theme directory. Supports keyword search, pagination, and browse modes. WordPress sites only.
 * @summary Search the WordPress theme directory
 */
export const searchSiteThemes = (
  id: SiteID,
  params?: SearchSiteThemesParams,
  signal?: AbortSignal
) => {
  return customFetch<SearchThemesResponse>({
    url: `/v1/sites/${id}/themes/search`,
    method: 'GET',
    params,
    signal,
  });
};

export const getSearchSiteThemesQueryKey = (id?: SiteID, params?: SearchSiteThemesParams) => {
  return [`/v1/sites/${id}/themes/search`, ...(params ? [params] : [])] as const;
};

export const getSearchSiteThemesQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>>;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSiteThemesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSiteThemes>>> = ({ signal }) =>
    searchSiteThemes(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/themes/search`,
      operationId: 'app.controllers.themes_controller.search_site_themes',
      operationName: 'searchSiteThemes',
    }
  );

  return customOptions as UseQueryOptions<
    Awaited<ReturnType<typeof searchSiteThemes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchSiteThemesQueryResult = NonNullable<Awaited<ReturnType<typeof searchSiteThemes>>>;
export type SearchSiteThemesQueryError = Error;

export function useSearchSiteThemes<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | SearchSiteThemesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSiteThemes>>,
          TError,
          Awaited<ReturnType<typeof searchSiteThemes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSiteThemes<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchSiteThemes>>,
          TError,
          Awaited<ReturnType<typeof searchSiteThemes>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSiteThemes<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the WordPress theme directory
 */

export function useSearchSiteThemes<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchSiteThemesQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getSearchSiteThemesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSearchSiteThemesQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof searchSiteThemes>>> = ({ signal }) =>
    searchSiteThemes(id, params, signal);

  const customOptions = addMetaToQuery(
    { ...queryOptions, queryKey, queryFn },
    { id, params },
    {
      url: `/v1/sites/${id}/themes/search`,
      operationId: 'app.controllers.themes_controller.search_site_themes',
      operationName: 'searchSiteThemes',
    }
  );

  return customOptions as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof searchSiteThemes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchSiteThemesSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchSiteThemes>>
>;
export type SearchSiteThemesSuspenseQueryError = Error;

export function useSearchSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params: undefined | SearchSiteThemesParams,
  options: {
    query: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSearchSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Search the WordPress theme directory
 */

export function useSearchSiteThemesSuspense<
  TData = Awaited<ReturnType<typeof searchSiteThemes>>,
  TError = Error,
>(
  id: SiteID,
  params?: SearchSiteThemesParams,
  options?: {
    query?: Partial<
      UseSuspenseQueryOptions<Awaited<ReturnType<typeof searchSiteThemes>>, TError, TData>
    >;
  },
  queryClient?: QueryClient
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSearchSiteThemesSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions, queryClient) as UseSuspenseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
